/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';


@Injectable({
  providedIn: 'root',
})
export class InfrastructureService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation infrastructureClearCache
   */
  static readonly InfrastructureClearCachePath = '/v1/admin/infrastructure/clear-cache';

  /**
   * Clears all data stored in Redis.
   *
   * Use this endpoint to clean Redis DB. For more details please see the following Redis Commands:
   * FLUSHDB
   * FLUSHALL
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `infrastructureClearCache()` instead.
   *
   * This method doesn't expect any request body.
   */
  infrastructureClearCache$Response(params?: {

    /**
     * Redis DB number. The parameter is optional.
     */
    databaseId?: number;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, InfrastructureService.InfrastructureClearCachePath, 'post');
    if (params) {
      rb.query('databaseId', params.databaseId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Clears all data stored in Redis.
   *
   * Use this endpoint to clean Redis DB. For more details please see the following Redis Commands:
   * FLUSHDB
   * FLUSHALL
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `infrastructureClearCache$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  infrastructureClearCache(params?: {

    /**
     * Redis DB number. The parameter is optional.
     */
    databaseId?: number;
  }): Observable<void> {

    return this.infrastructureClearCache$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
